module.exports = __webpack_public_path__ + "static/media/unknown.ae36cfd0.png";